<div class="select-product-modal">

  <app-search-bar
    placeholder="Buscar producto por nombre"
    (search)="onSearch($event)"
  />

  <div class="product-list">
    @if (isLoading()) {
      <p class="product-list__state">Cargando productos...</p>
    } @else if (filteredProducts().length === 0) {
      <p class="product-list__state">No se encontraron productos.</p>
    } @else {
      @for (product of filteredProducts(); track product.id) {
        <div class="product-item" [class.product-item--selected]="isSelected(product)">
          <img
            class="product-item__image"
            [src]="getProductImageUrl(product)"
            [alt]="product.name"
          />

          <div class="product-item__info">
            <span class="product-item__name">{{ product.name }}</span>
            <span class="product-item__price">{{ product.basePrice | clpCurrency }}</span>
            @if (isComingSoon(product)) {
              <span class="product-item__badge">{{ texts.COMING_SOON_BADGE }}</span>
              <span class="product-item__warning">{{ texts.COMING_SOON_WARNING }}</span>
            }
          </div>

          <button
            type="button"
            class="product-item__btn"
            [class.product-item__btn--selected]="isSelected(product)"
            [disabled]="isSaving()"
            (click)="onSelect(product)"
          >
            {{ isSelected(product) ? 'Seleccionado' : 'Elegir' }}
          </button>
        </div>
      }
    }
  </div>

</div>
